function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretdoubleleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.037 3.757a.75.75 0 00-.817.163L12 10.14V4.45a.75.75 0 00-1.28-.53l-7.5 7.5a.75.75 0 000 1.06l7.5 7.5a.75.75 0 001.28-.53v-5.69l6.22 6.22a.75.75 0 001.28-.53v-15a.75.75 0 00-.463-.693z",
    fill: props.fill
  }));
}

export default SvgCaretdoubleleft;